import React, { useState, useEffect } from "react";
import { useIntl } from "react-intl";
import styled from "@emotion/styled";

import Alert from "@mui/material/Alert";
import Button from "@mui/material/Button";
import Collapse from "@mui/material/Collapse";

import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

import Config from "services/api/config";

const StyledButton = styled(Button)`
  margin-right: 20px;
  line-height: 1.2;
`;
const StyledAlert = styled(Alert)`
  display: flex;
  align-items: center;
  height: 45px;
`;
const StyledCollapse = styled(Collapse)`
  display: ${(props) => (props.in ? "table" : "flex")};
`;

function useWindowSize() {
  const [windowSize, setWindowSize] = useState({
    width: 0,
    height: 0,
  });
  useEffect(() => {
    function handleResize() {
      setWindowSize({
        width: window?.innerWidth,
        height: window?.innerHeight,
      });
    }
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return windowSize;
}

function MobileAppAlert() {
  const { formatMessage } = useIntl();
  const [alreadyClosed, setAlreadyClosed] = useState(false);
  const [open, setOpen] = useState(false);
  const { width } = useWindowSize();

  useEffect(() => {
    if (!alreadyClosed && width > 0) {
      setOpen(width <= 700);
    }
  }, [alreadyClosed, width]);

  function handleOpenMobileAppUrl() {
    window?.open(Config?.mobileAppUrl, "_blank")?.focus();
  }

  function handleCloseAlert() {
    setOpen(false);
    setAlreadyClosed(true);
  }

  return (
    <StyledCollapse in={open}>
      <StyledAlert
        variant="standard"
        severity="info"
        action={
          <>
            <StyledButton
              variant="contained"
              color="primary"
              size="small"
              onClick={handleOpenMobileAppUrl}
            >
              {formatMessage({ id: "components.buttons.keyNumbers" })}
            </StyledButton>
            <IconButton
              aria-label="close"
              color="secondary"
              size="small"
              onClick={handleCloseAlert}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          </>
        }
      >
        {formatMessage({ id: "components.mobileAppAlert.title" })}
      </StyledAlert>
    </StyledCollapse>
  );
}

export default MobileAppAlert;
